import { createContext } from "react";
import { useState } from "react";
import { useEffect } from "react";

import api from "../api/axios";

export const AuthContext =
    createContext();

export function AuthProvider({

    children

}) {

    const [user, setUser] =
        useState(null);

    const [loading, setLoading] =
        useState(true);

    useEffect(() => {

        const token =
            localStorage.getItem("token");

        if (!token) {

            setLoading(false);

            return;

        }

        api.get("/api/profile")

            .then((res) => {

                setUser(res.data);

            })

            .catch(() => {

                logout();

            })

            .finally(() => {

                setLoading(false);

            });

    }, []);

    async function login(

        email,

        password

    ) {

        const res = await api.post(

            "/auth/login",

            {

                email,

                password

            }

        );

        localStorage.setItem(

            "token",

            res.data.token

        );

        localStorage.setItem(

            "user",

            JSON.stringify(

                res.data.user

            )

        );

        setUser(res.data.user);

        return true;

    }

    function logout() {

    localStorage.removeItem("token");

    localStorage.removeItem("user");

    setUser(null);

    window.location.href = "/login";

}

    return (

        <AuthContext.Provider

            value={{

                user,

                loading,

                login,

                logout

            }}

        >

            {children}

        </AuthContext.Provider>

    );

}